import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpPillInfoComponent } from "./bp-pill-info.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";

@NgModule({
	declarations: [BpPillInfoComponent],
	exports: [BpPillInfoComponent],
	imports: [CommonModule, TranslationPipeModule]
})
export class BpPillInfoModule {}
